import React, { useCallback } from 'react';
import { useIntl, IntlProvider } from 'react-intl';
import useApplicationForm from './useApplicationForm';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { Typography, makeStyles } from '@ellucian/react-design-system/core';
import debounce from 'lodash/debounce';
import { WatchValues } from '@nsr/react-form';
import ApplicationForm from './ApplicationForm';
import HtmlFormattedMessage from '../HtmlFormattedMessage/HtmlFormattedMessage';
import PropTypes from 'prop-types';

const autosaveInterval = 500;

const useStyles = makeStyles({
    recaptchaBranding: {
        textAlign: 'center',
        margin: `0 ${spacing40} 0 ${spacing40}`,
    }
});
const ApplicationFormLayout = (props) => {
    const { isAps } = props;
    const intl = useIntl();
    const ctx = useApplicationForm();
    const { formMessages, adminTenant } = ctx;
    useStyles();
    const callAutosave = useCallback(
        debounce(ctx.autosave, autosaveInterval),
        [ctx.autosave]
    );
 
    if (ctx.template === null || formMessages === null) {
        return null;
    }
    const globalSettings = window.PRELOADED_STATE?.globalSettings || adminTenant;
    const { recaptcha } = globalSettings;

    return (
        <IntlProvider locale={intl.locale} messages={formMessages}>
            <>
                { !isAps && 
                    <WatchValues onValuesChange={callAutosave} />
                }
                <ApplicationForm />
                {
                    recaptcha?.recaptchaToggle && <RecaptchaBranding/>
                }
                {/* <ReduxStateDump /> */}
            </>
        </IntlProvider>
    );
};

ApplicationFormLayout.propTypes = {
    isAps: PropTypes.bool,
};

const RecaptchaBranding = () => {
    const classes = useStyles();

    return (
        <aside aria-label='Recaptcha Branding' >
            <Typography className={classes.recaptchaBranding}>
                <HtmlFormattedMessage descriptor={{ id: 'recaptchaBranding' }} />
            </Typography>
        </aside>
    );
};

export default ApplicationFormLayout;
